import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Wind, Cog, Wrench, Shield, Droplet, ArrowRight } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { servicesData } from '../mock';

const iconMap = {
  wind: Wind,
  cog: Cog,
  wrench: Wrench,
  shield: Shield,
  droplet: Droplet
};

const Services = () => {
  const navigate = useNavigate();

  return (
    <section id="services" className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Xidmətlərimiz
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Sənaye və kommersiya obyektləri üçün kompleks texniki həllər
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {servicesData.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card
                key={service.id}
                className="group hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border-none bg-white overflow-hidden cursor-pointer"
                style={{
                  animationDelay: `${index * 100}ms`
                }}
                onClick={() => navigate(`/services/${service.slug}`)}
              >
                {/* Background Image */}
                <div
                  className="relative h-48 bg-cover bg-center"
                  style={{
                    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.6)), url(${service.image})`
                  }}
                >
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-lg">
                      {IconComponent && <IconComponent className="text-white" size={32} />}
                    </div>
                  </div>
                </div>

                <CardHeader>
                  <CardTitle className="text-2xl font-bold text-gray-900 group-hover:text-blue-600 transition-colors duration-200">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-gray-600 text-base leading-relaxed mb-4">
                    {service.description}
                  </CardDescription>
                  <Button
                    variant="ghost"
                    className="group/btn p-0 h-auto text-blue-600 hover:text-blue-700 font-semibold"
                  >
                    Ətraflı
                    <ArrowRight className="ml-1 group-hover/btn:translate-x-1 transition-transform duration-200" size={16} />
                  </Button>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
